<div class="input-group">
    <input type="text" 
        data-test-selector="date-input"
        class="form-control"
        [id]="id"
        placeholder="mm/dd/yyyy"
        [name]="name"
        [(ngModel)]="date"
        [required]="isRequired"
        placement="top"
        ngbDatepicker
        [minDate]="minDate"
        [maxDate]="maxDate"
        [markDisabled]="isDateDisabled"
        #datePicker="ngbDatepicker"
        [dayTemplate]="customDay"
        [firstDayOfWeek]="7"
        #model="ngModel"
        (ngModelChange)="onDateSelection($event, model.control.valid)"
        [datePickerInputValidator]="{ isWeekendEnabled }"
        [disabled]="disabled"
    >
    <button
        data-test-selector="date-btn"
        class="btn btn-sm btn-outline-secondary"
        (click)="datePicker.toggle()"
        type="button"
        [disabled]="isButtonDisabled"
    ><i class={{icon}}></i></button>
</div>
<ng-template #customDay
    let-date
    let-selected="selected"
    let-disabled="disabled"
    let-focused="focused"
>
    <span
        class="custom-day"
        [class.today]="isHighlightTodayEnabled && isToday(date)"
        [class.focused]="focused"
        [class.bg-primary]="selected"
        [class.text-muted]="disabled"
    >
        {{ date.day }}
    </span>
</ng-template>